import React from 'react';
import './largevideo.css';


const LargeVideo = ({ lgvideolink}) => {
    return (
        <div className='center-media__container'>
            <div className="video__wrap">
                <video src={lgvideolink} alt='Etheware Video' autoPlay muted loop controls="false"/>
            </div>
        </div>
    );
}

export default LargeVideo;
